<div class="d-flex align-items-end justify-content-between mb-4">
    <h6 class="montserrat-medium text-gray-500">Campaign summary</h6>

    <div style="display: flex; flex-direction: column; gap: 5px">
        <button class="btn btn-lg btn-gray-500" (click)="publishCampaign()" *ngIf="!previewMode || editMode"
            [disabled]="hasNoActiveChannels()">
            publish campaign
        </button>

        <div style="display: flex; flex-direction: row; gap: 5px; align-items: center">
            <mat-form-field class="form-group dark-input" style="min-width: 220px">
                <mat-label>Download Media Plan</mat-label>
                <mat-select [(ngModel)]="selectedFileType" (selectionChange)="onFileTypeSelect($event.value)"
                    [disabled]="loading" class="multiline-mat-select" panelClass="select-panel-down sided-select">
                    <mat-option value="excel" class="text-capitalize multiline-mat-option">Excel</mat-option>
                    <mat-option value="pdf" class="text-capitalize multiline-mat-option">PDF</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
        </div>
    </div>
</div>

<app-highlights *ngIf="campaign" [step]="5" [campaign]="campaign"></app-highlights>

<div class="d-xl-flex align-items-start justify-content-between">
    <div class="flex-grow-1 mx-xl-3">
        <div class="bg-gray-200 p-3 br-15 mb-4">
            <div class="tableHolder table-responsive custom-table mb-5">
                <app-campaign-media-summary-table [rows]="dataSource" [isEditMode]="editMode || liveEditMode"
                    [showChannelStatusDistinction]="showChannelStatusDistinction()"
                    [getChannelStatusForMedia]="getChannelSupplierStatusForMedia" [campaign]="campaign"
                    [columns]="displayedColumns"></app-campaign-media-summary-table>
            </div>

            <div class="tableHolder table-responsive custom-table mb-5">
                <div class="bloc-title mb-3">Municipality fees</div>
                <p class="bloc-title mb-3 text-italic text-bold pl-2" style="color: #dc3545">
                    (This is the estimated amount, calculated based on the visual count provided
                    earlier and the actual municipality fees paid by the supplier on your behalf)
                </p>
                <app-municipality-fees-summary-table [rows]="dataSourceMunicipality"
                    [columns]="displayedColumnsMunicipality"
                    [isSupplier]="isSupplier"></app-municipality-fees-summary-table>
            </div>
            <div>
                <app-campaign-total-price-summary-section *ngIf="campaign"
                    [sectionData]="sectionData"></app-campaign-total-price-summary-section>
            </div>
            <button class="btn btn-lg btn-gray-500 float-right" (click)="publishCampaign()" *ngIf="!previewMode"
                [disabled]="hasNoActiveChannels()">
                publish campaign
            </button>
            <div class="clearfix"></div>
        </div>
    </div>
</div>
<ng-template #noData>
    <span class="text-gray">__</span>
</ng-template>